import React from 'react';
import {Edit, SimpleForm, TextInput, required, minLength, BooleanInput} from 'react-admin';
import {HASH_TAG} from '../../consts/Names';

export const HashTagEdit = (props) => (
   <Edit {...props} undoable={false} title='Edit hashtags'>
      <SimpleForm >
        <TextInput label="Hashtag Name" source={HASH_TAG.name} validate={[required(), minLength(3)]}  parse={v => {
               return v.toLowerCase().trim().replace(/\W/g, '');}
               }/>
         <BooleanInput label="Snapshot Hashtags" source="is_snapshot" />

      </SimpleForm>
   </Edit>
);
